import React from 'react';
import fileDownload from 'js-file-download';
import axios from '../../../utils/axios';
import './help-pdf-download.scss';
import { default as t } from '../../../utils/i18n';
import config from '../../../utils/config';
import axiosStat from "axios";

const HelpPdfDownload = ({isLinearView = false}) => {

    const HELP_SUPPORT_LINK = config.get('help', 'support_link_performance');

    const handleDownload = (url, filename) => {
        const userGuideUrl = url.replace(/\{(.*?)\}/gi,t('dashboard.link.helpAndSupport',true));
        const api = axiosStat.create({
            baseURL: axios.defaults.baseURL.slice(0,-4),
           });
           api.get(userGuideUrl, {
                responseType: 'blob',
            }).then((res) => {
                fileDownload(res.data, filename)
            })
    }
    
    return (
        <div className='help-pdf'>
            {isLinearView && <div className='linear-view'>
                <div className='attribute-detail-view-header'>
                    <span className='attribute-detail-view-headertext'>{t('download.pdf.info.question')}</span>
                    <button className='download-snapshot' onClick={() => handleDownload(HELP_SUPPORT_LINK, 'help.pdf')}>
                        <i className="eva eva-message-circle-outline"></i>
                        {t('download.pdf.button.label')}
                    </button>
                </div>
            </div>}

            {!isLinearView && <div className='popup-view'>
                <div className="ques-instruction">
                    <span>{t('download.pdf.info.question')}</span>
                    <button onClick={() => { handleDownload(HELP_SUPPORT_LINK, 'help.pdf') }} className="download">
                        <i className="eva eva-message-circle-outline"></i>
                        {t('download.pdf.button.label')}
                    </button>
                </div>
            </div> }
        </div>
    );
}

export default HelpPdfDownload;
